import type { Company } from '@types'
import axios from 'axios'

import env from '../environments'

export async function getCompanyBySlug(slug: string) {
	const response = await axios.get(`${env.apiUrl}/companies/${slug}`)

	return response.data as Company
}
